document.addEventListener('DOMContentLoaded', () => {
  const $header = document.querySelector('nova-header')
  const $openMenu = $header.querySelector('.js-menu-toggle')
  const $closeMenu = $header.querySelector('.js-menu-close-button')

  const $drawerButtons = $header.querySelectorAll('.js-header-drawer-button')

  const $menuDrawerButtons = [...$drawerButtons].filter(
    (button) => button.dataset.type !== 'search',
  )

  const $headerDrawer = $header.querySelectorAll('.js-header-drawer')

  const $menuDrawer = [...$headerDrawer].filter(
    (drawer) => drawer.dataset.type !== 'search',
  )

  const $searchDrawers = $header.querySelectorAll(
    '.js-header-drawer[data-type="search"]',
  )

  document.addEventListener('nova:searchDrawer:close', () => {
    for (const $searchDrawer of $searchDrawers) {
      $searchDrawer.hide()
    }
  })

  $openMenu.addEventListener('click', () => {
    $openMenu.classList.add('hidden')
    $openMenu.setAttribute('aria-hidden', 'true')
    $openMenu.setAttribute('tabindex', '-1')

    $closeMenu.classList.remove('hidden')
    $closeMenu.removeAttribute('aria-hidden')
    $closeMenu.setAttribute('tabindex', '0')

    document.dispatchEvent(new CustomEvent('nova:mobile-menu:open'))
  })

  const mobileMenuDrawer = document.getElementById('mobile-menu')

  document.addEventListener('nova:menu:closed-in-modal', () => {
    handleMenuIconClose()
  })

  const handleMenuIconClose = () => {
    $closeMenu.classList.add('hidden')
    $closeMenu.setAttribute('aria-hidden', 'true')
    $openMenu.classList.remove('hidden')
    $openMenu.removeAttribute('aria-hidden')
    document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'))
  }

  mobileMenuDrawer.addEventListener('sl-hide', handleMenuIconClose)
  $closeMenu.addEventListener('click', handleMenuIconClose)

  const handleInlineMenuDrawer = (event) => {
    const $button = event.target.closest('.js-header-drawer-button')
    if (!$button) return

    const targetReference = $button.dataset.target
    const $target = $header.querySelector(`#${targetReference}`)
    if (!$target) return

    if (event.type !== 'mouseenter') {
      if ($button.hasAttribute('is-open')) {
        $target.hide()
        return
      }
    }

    for (const $drawer of $headerDrawer) {
      if ($drawer === $target) {
        if (!$drawer.hasAttribute('is-open')) {
          $drawer.show()
        }
      } else {
        $drawer.hide()
      }
    }
  }

  const closeDrawer = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    $drawer.hide()
  }

  for (const $button of $drawerButtons) {
    $button.addEventListener('click', handleInlineMenuDrawer)
  }

  const handleDrawerAttributesAndEvents = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')

    if (!$drawer) return
    const targetReference = $drawer.id
    const $button = $header.querySelector(`[data-target="${targetReference}"]`)
    const $buttonOpenIcon = $button.querySelector('.js-header-drawer-icon-open')
    const $buttonCloseIcon = $button.querySelector(
      '.js-header-drawer-icon-close',
    )
    if (!$button) return
    if (event.type === 'sl-hide') {
      $drawer.removeAttribute('is-open')
      $button.removeAttribute('is-open')
      if ($buttonOpenIcon && $buttonCloseIcon) {
        $buttonOpenIcon.classList.remove('visually-hidden')
        $buttonCloseIcon.classList.add('visually-hidden')
      }
      dispatchDrawerHideEvent($drawer)
    } else if (event.type === 'sl-show') {
      $drawer.setAttribute('is-open', '')
      $button.setAttribute('is-open', '')
      if ($buttonOpenIcon && $buttonCloseIcon) {
        $buttonOpenIcon.classList.add('visually-hidden')
        $buttonCloseIcon.classList.remove('visually-hidden')
      }
      dispatchDrawerShowEvent($drawer)
    }
  }

  const dispatchDrawerShowEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:open', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  const dispatchDrawerHideEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:close', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  for (const $drawer of $headerDrawer) {
    $drawer.addEventListener('sl-hide', handleDrawerAttributesAndEvents)
    $drawer.addEventListener('sl-show', handleDrawerAttributesAndEvents)
  }

  for (const $button of $menuDrawerButtons) {
    $button.addEventListener('mouseenter', handleInlineMenuDrawer)
  }

  for (const $drawer of $menuDrawer) {
    $drawer.addEventListener('mouseleave', closeDrawer)
  }
})
